import { memo, useEffect, useState } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import PortalIdParser from 'PortalIdParser';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { getFullUrl } from 'hubspot-url-utils';
import { SALES_HUB_PROFESSIONAL } from 'self-service-api/constants/ApiNames';
import { SALES_PROFESSIONAL } from 'self-service-api/constants/UpgradeProducts';
import { MERCH_CARD } from 'ui-addon-upgrades/_core/common/constants/PurchaseMotionLocations';
import * as upgradeTracker from 'ui-addon-upgrades/_core/common/eventTracking/tracker';
import * as PURCHASE_MOTIONS_ENUM from 'ui-addon-upgrades/_core/purchaseMotions/PurchaseMotionTypes';
import UIPurchaseMotionButton from 'ui-addon-upgrades/button/UIPurchaseMotionButton';
import { getSalesHubPurchaseMotionsForMerchCard } from '../../../clients/monetizationClient';
import { Button } from 'foundations-components/transitional/components/Button';
import { jsx as _jsx } from "react/jsx-runtime";
const getPricingPageUrl = () => `/pricing/${PortalIdParser.get()}/`;
const FetchStates = {
  loading: 'loading',
  success: 'success',
  error: 'error'
};
const TrialButton = /*#__PURE__*/memo(({
  upgradeData
}) => /*#__PURE__*/_jsx(UIPurchaseMotionButton, {
  purchaseMotions: [PURCHASE_MOTIONS_ENUM.TRIAL],
  level: 1,
  upgradeData: upgradeData,
  children: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "marketplace-ui-apps-core.installButton.purchaseMotions.trial"
  })
}));
const PurchaseMotionButton = ({
  fallback
}) => {
  const app = 'market-place-ui';
  const upgradeData = {
    app,
    screen: 'detail',
    uniqueId: 'connect-button',
    apiName: SALES_HUB_PROFESSIONAL,
    upgradeProduct: SALES_PROFESSIONAL
  };
  const [purchaseMotion, setPurchaseMotion] = useState();
  const [fetchState, setFetchState] = useState(FetchStates.loading);
  const [showTooltip, setShowTooltip] = useState(true);
  const handleBuyClick = () => {
    upgradeTracker.track('interaction', {
      action: 'clicked interstitial redirect',
      screen: 'detail',
      upgradeProduct: SALES_PROFESSIONAL
    });
    const interstitialUrl = `${getFullUrl('app')}${getPricingPageUrl()}interstitial?products=sales-hub-professional_1`;
    window.open(interstitialUrl, '_blank');
  };
  const handleTrialClick = () => {
    setShowTooltip(false);
  };
  useEffect(() => {
    getSalesHubPurchaseMotionsForMerchCard().then(purchaseMotionData => {
      const purchaseMotions = purchaseMotionData.purchaseMotionsMapping.productsByLocation[MERCH_CARD].purchaseMotionsByProductApiName[SALES_HUB_PROFESSIONAL].purchaseMotions;
      if (purchaseMotions.includes('TRIAL')) {
        setPurchaseMotion(PURCHASE_MOTIONS_ENUM.TRIAL);
      } else if (purchaseMotions.includes('BUY_TOUCHLESS')) {
        setPurchaseMotion(PURCHASE_MOTIONS_ENUM.BUY_TOUCHLESS);
      }
      setFetchState(FetchStates.success);
    }).catch(() => {
      setFetchState(FetchStates.error);
    });
  }, []);
  if (fetchState === FetchStates.loading) {
    return null;
  } else if (fetchState === FetchStates.error) {
    return fallback;
  }
  if (purchaseMotion === PURCHASE_MOTIONS_ENUM.TRIAL) {
    return /*#__PURE__*/_jsx(Tooltip, {
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "marketplace-ui-apps-core.installButton.purchaseMotions.tooltip"
      }),
      disabled: !showTooltip,
      children: /*#__PURE__*/_jsx("span", {
        onClick: handleTrialClick,
        children: /*#__PURE__*/_jsx(TrialButton, {
          upgradeData: upgradeData
        })
      })
    });
  }
  if (purchaseMotion === PURCHASE_MOTIONS_ENUM.BUY_TOUCHLESS) {
    return /*#__PURE__*/_jsx(Tooltip, {
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "marketplace-ui-apps-core.installButton.purchaseMotions.tooltip"
      }),
      children: /*#__PURE__*/_jsx(Button, {
        onClick: handleBuyClick,
        use: "primary",
        target: "_blank",
        truncate: true,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "marketplace-ui-apps-core.installButton.purchaseMotions.buyTouchless"
        })
      })
    });
  }
  return fallback;
};
export default PurchaseMotionButton;